import { DocumentData, Firestore, QuerySnapshot } from 'firebase/firestore';
import { typeUniqueId } from "../../../../dataObjects/types"
import { IFirestoreImageLinkRepository } from "../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreImageLinkRepository";
import { FirestoreDataRepositoryFactory } from '../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreDataRepositoryFactory';
import { enumFirestoreDataRepositoryDataType } from '../../../cloudServices/googleFirebaseServices/database/firestore/enums';
import { IFirestoreBaseRepository } from '../../../cloudServices/googleFirebaseServices/database/firestore/FirestoreBaseRepository';
import { IImageLink, IImageLinkAsJson } from '../../../../dataObjects/models/digitalMedia/ImageLink';


export function getImageLinkById_onSnapshot(imageLinkId: typeUniqueId, callback: (snapshot: QuerySnapshot<DocumentData>) => void): Promise<() => void> {
  return new Promise<() => void>(async (resolve, reject) => {
    try {
      // get an ImageLink repository from the repository factory
      const firestoreImageLinkRepository: IFirestoreImageLinkRepository =
        FirestoreDataRepositoryFactory.CreateDataRepository(enumFirestoreDataRepositoryDataType.ImageLink) as
        IFirestoreBaseRepository<IImageLink, IImageLinkAsJson>;

      // fetch the imageLink for the pertinent Id
      const unsubscribeCallback: () => void = await firestoreImageLinkRepository.get_onSnapshot(imageLinkId, callback);

      resolve(unsubscribeCallback);
    }
    catch (error: any) {
      reject(error);
    }
  });
}